import { getState } from '~src/state';

export const confirmExit = () => {
  const totalChangesSinceLastSave = getState('totalChangesSinceLastSave');

  if (totalChangesSinceLastSave && !window.origin.includes('localhost')) {
    return 'Alcune modifiche non sono state salvate. Sei sicuro di voler chiudere?';
  }
};
